import { render, staticRenderFns } from "./GroupHead.vue?vue&type=template&id=26954adc&scoped=true&lang=pug"
import script from "./GroupHead.vue?vue&type=script&lang=js"
export * from "./GroupHead.vue?vue&type=script&lang=js"
import style0 from "./GroupHead.vue?vue&type=style&index=0&id=26954adc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26954adc",
  null
  
)

export default component.exports